module.exports = __webpack_public_path__ + "static/img/arrow_white.fa20ed9.png";